
import { supabase } from "../supabase-client";

export const getUserCompletedChallenges = async (
  userId: string
) => {
    try {
        const { data, error } = await supabase
          .from("completed_challenges")
          .select("challenge_id, points_earned, beat_crowd, completed_at")
          .eq("user_id", userId)
          .order("completed_at", { ascending: false });
  
        if (error) {
          console.error("Error fetching completed challenges:", error);
          return [];
        }
  
        return data || [];
      } catch (error) {
        console.error("Error fetching completed challenges:", error);
        return [];
      }
};